import { styled } from 'stitches';
export const Box = styled('div', {});